import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../searchresults/Address";
import getPersonName from "../common/Name";
import getPhone from "../common/Phone";

class CommonResidencyDetail extends Component {
  componentDidMount() {}

  render() {
    const concurrentSharedPersons = [];
    const nonConcurrentSharedPersons = [];
    if (
      this.props.commonResidencyNode !== undefined &&
      this.props.commonResidencyNode !== null
    ) {
      const persons = _.get(
        this.props.commonResidencyNode,
        "sharedAddress[0].person"
      );
      _.forEach(persons, (person, index) => {
        const apt = _.get(person, "address[0].unitDesignatorNumber[0]._");
        const cols = [];
        cols.push(
          <Table.Cell key={`com_res_pers_name_title_${index}`}>
            <span className="text-bold">Name:</span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`com_res_pers_name_${index}`}>
            {getPersonName(
              _.get(person, "firstName[0]._", ""),
              _.get(person, "middleName[0]._", ""),
              _.get(person, "lastName[0]._", ""),
              this.props
            )}
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`com_res_pers_age_title_${index}`}>
            <span className="text-bold">Age:</span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`com_res_pers_age_${index}`}>
            {_.get(person, "age[0]._")}
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`com_res_pers_phone_title_${index}`}>
            <span className="text-bold">
              {person.phone === undefined || person.phone[0] === undefined
                ? ""
                : "Phone:"}
            </span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`com_res_pers_phone_${index}`}>
            {getPhone(_.get(person, "phone[0]._"), this.props)}
            {apt !== undefined ? ` Apt: ${apt}` : ""}
          </Table.Cell>
        );
        const concurPers = _.get(
          person,
          "concurrentSharedAddressPerson[0]._",
          ""
        );
        if (concurPers !== "" && concurPers === "Yes") {
          concurrentSharedPersons.push(
            <Table.Row
              key={`Con_Res_Header_Row_${index}`}
              className={index % 2 === 1 ? "table-row-odd-child" : ""}
            >
              {cols}
            </Table.Row>
          );
        } else {
          nonConcurrentSharedPersons.push(
            <Table.Row
              key={`Con_Res_Header_Row_${index}`}
              className={index % 2 === 1 ? "table-row-odd-child" : ""}
            >
              {cols}
            </Table.Row>
          );
        }
      });
    }
    const dateFrom = _.get(this.props.commonResidencyNode, "dateFrom[0]._", "");
    const dateTo = _.get(this.props.commonResidencyNode, "dateTo[0]._", "");
    return (
      <div>
        <Table stackable key={"Common_Residency_Header_Name"}>
          <Table.Body>
            <Table.Row className="report-sub-section-header">
              <Table.HeaderCell widt={12}>
                <Address
                  addressNode={this.props.commonResidencyNode}
                  {...this.props}
                  fullAddress={_.get(
                    this.props.commonResidencyNode,
                    "fullAddress[0]._"
                  )}
                  ignoreLine1
                  noBreakIconsAndText
                />
              </Table.HeaderCell>
              <Table.HeaderCell widt={4} className={"text-right"}>
                {`${dateFrom}${dateFrom !== "" ? "-" : ""}${dateTo}`}
              </Table.HeaderCell>
            </Table.Row>
            {concurrentSharedPersons.length > 0 && (
              <Table.Row>
                <Table.Cell colSpan={2}>
                  <Table>
                    <Table.Body>
                      <Table.Row className="report-sub-sub-section-header">
                        <Table.HeaderCell colSpan={6}>
                          Concurrent Residency
                        </Table.HeaderCell>
                      </Table.Row>
                      {concurrentSharedPersons}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            )}
            {nonConcurrentSharedPersons.length > 0 && (
              <Table.Row>
                <Table.Cell colSpan={2}>
                  <Table>
                    <Table.Body>
                      <Table.Row className="report-sub-sub-section-header">
                        <Table.HeaderCell colSpan={6}>
                          Non-Concurrent Residency
                        </Table.HeaderCell>
                      </Table.Row>
                      {nonConcurrentSharedPersons}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        <br />
      </div>
    );
  }
}

export default CommonResidencyDetail;



// WEBPACK FOOTER //
// ./src/components/reports/CommonResidencyDetail.js